export enum ApprovalType {
  Employee = 1,
  InternalEmployee = 2,
  ExternalEmployee = 3,
}
